import { Link, useLocation } from 'react-router-dom';
import { Mark } from '@/components/ui/Mark';
import { featuredSlug } from '@/content/registry';
import styles from './SiteFooter.module.css';

export function SiteFooter() {
  const { pathname } = useLocation();

  // Hidden during the journey. A round is short enough that a footer full of
  // links is just a set of ways to abandon it.
  if (pathname.includes('/questions')) return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandBlock}>
          <span className={styles.brand}>
            <Mark size={22} />
            Are We Compatible?
          </span>
          <p className={styles.blurb}>
            A dating profile that asks questions back. Built by one person in Auckland,
            for the unreasonable purpose of having better first conversations.
          </p>
        </div>

        <nav className={styles.links} aria-label="Footer">
          <Link to="/">Home</Link>
          <Link to={`/${featuredSlug}`}>Meet James</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>

        <div className={styles.fine}>
          <span>Auckland, New Zealand</span>
          <span>No accounts. No tracking. No swiping.</span>
        </div>
      </div>
    </footer>
  );
}
